import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { UnlicensedInstance } from "./UnlicensedData";

// Helper function to format date to DD-MM-YYYY
function formatDate(isoDate: string): string {
  if (!isoDate) return "";
  const dateObj = new Date(isoDate);
  const dd = String(dateObj.getDate()).padStart(2, "0");
  const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
  const yyyy = dateObj.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export function makeUnlicensedFields(): FilterField<UnlicensedInstance>[] {
  const fields: FilterField<UnlicensedInstance>[] = [
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Description",
      key: "description",
      accessor: (r) => r.description,
      type: "string",
      inFreeText: true,
    },
    {
      label: "ID",
      key: "id",
      accessor: (r) => r.id,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Deactivate",
      key: "deactivate",
      accessor: (r) => formatDate(r.deactivate),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Last Update",
      key: "lastupdate",
      accessor: (r) => formatDate(r.lastupdate),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Subscription",
      key: "subscription",
      accessor: (r) => r.Suscription || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Activated",
      key: "activated",
      accessor: (r) => formatDate(r.activated),
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

